export const enUS = {
  login: 'Login',
  logout: 'Logout',
}
